import { TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";

import { PortSummary } from "../../../port-summary/port-summary";
import { ConfigurationDetails } from "../../../tabbed-detail-container/components/configuration-details/configuration-details";
import { propertyKeysToRows } from "../../../tabbed-detail-container/tabbed-detail-container.helpers";
import { TransformedL3vpnSap } from "../../l3vpn-sap";

@Component({
  selector: "l3vpn-sap-panel",
  templateUrl: "l3vpn-sap-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ConfigurationDetails, PortSummary],
})
export class L3vpnSapPanel {
  private translate = inject(TranslateService);

  sap = input.required<TransformedL3vpnSap>();

  protected configurationDetails = computed(() => {
    const s = this.sap();
    const rows = propertyKeysToRows(
      this.translate,
      [
        { key: "bgpMetric", title: "IP.BGPMetric" },
        { key: "bgpPassword", title: "IP.BGPPassword", if: !!s.bgpPassword },
        { key: "bfd", title: "IP.BFD" },
        { key: "bfdMinimumInterval", title: "IP.BFDMinimalInterval", if: !!(s.bfd && s.bfdMinimumInterval) },
        { key: "bfdMultiplier", title: "IP.BFDMultiplier", if: !!(s.bfd && s.bfdMultiplier) },
        { key: "l3vpn_ipv4Address", title: "IP.L3VPNNeighborIPv4" },
        { key: "l3vpn_ipv4RemoteAddress", title: "IP.CustomerNeighborIPv4" },
        { key: "ipv4Mtu", title: "IP.IPv4MTU" },
        { key: "ipv4MaxPrefix", title: "IP.IPv4MaxPrefix" },
        { key: "l3vpn_ipv6Address", title: "IP.L3VPNNeighborIPv6" },
        { key: "l3vpn_ipv6RemoteAddress", title: "IP.CustomerNeighborIPv6" },
        { key: "ipv6Mtu", title: "IP.IPv6MTU" },
        { key: "ipv6MaxPrefix", title: "IP.IPv6MaxPrefix" },
      ],
      s,
    );
    return { title: this.translate.instant("ServiceElement.IPConfiguration"), rows };
  });

  protected hasConfigurationDetails = computed(() => this.configurationDetails().rows.length > 0);
}
